// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XXvQ","toggleWrap":"styles_toggleWrap__37wtI","content":"styles_content__1IqTg","selectAreaCode":"styles_selectAreaCode__XP7_d"};